// Mock data para apresentação
import { addDays, subDays, format } from 'date-fns';

// Gerar dados de consumo de energia
const generateEnergyData = (days = 30) => {
  const data = [];
  const sites = ['Pragal', 'Santa Apolónia', 'Évora', 'Freixo'];
  
  for (let i = days; i >= 0; i--) {
    const date = subDays(new Date(), i);
    sites.forEach(site => {
      const baseConsumption = Math.floor(Math.random() * (500 - 200) + 200);
      data.push({
        data: format(date, 'yyyy-MM-dd'),
        local: site,
        consumo: baseConsumption + Math.floor(Math.random() * 50),
        desvio: (Math.random() * 20 - 10).toFixed(1)
      });
    });
  }
  return data;
};

// Gerar dados fotovoltaicos
const generateSolarData = (days = 30) => {
  const data = [];
  const sites = ['Pragal', 'Santa Apolónia', 'Évora', 'Freixo'];
  
  for (let i = days; i >= 0; i--) {
    const date = subDays(new Date(), i);
    sites.forEach(site => {
      const production = Math.floor(Math.random() * (400 - 150) + 150);
      const consumption = Math.floor(Math.random() * (300 - 100) + 100);
      data.push({
        data: format(date, 'yyyy-MM-dd'),
        local: site,
        producao: production,
        excedente: Math.max(0, production - consumption),
        consumo: consumption
      });
    });
  }
  return data;
};

// Gerar dados dos postos de carregamento
const generateChargingData = (days = 30) => {
  const data = [];
  const sites = ['Pragal', 'Santa Apolónia', 'Évora', 'Freixo'];
  const users = ['João Silva', 'Maria Santos', 'Pedro Costa', 'Ana Ferreira', 'Carlos Alves'];
  
  for (let i = days; i >= 0; i--) {
    const date = subDays(new Date(), i);
    sites.forEach(site => {
      const numCharges = Math.floor(Math.random() * 5) + 1;
      for (let j = 0; j < numCharges; j++) {
        const startHour = Math.floor(Math.random() * 20) + 6;
        const duration = Math.floor(Math.random() * 4) + 1;
        data.push({
          data: format(date, 'yyyy-MM-dd'),
          local: site,
          posto: `P${Math.floor(Math.random() * 4) + 1}`,
          horaInicio: `${startHour.toString().padStart(2, '0')}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
          horaFim: `${(startHour + duration).toString().padStart(2, '0')}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
          consumo: (Math.random() * 50 + 20).toFixed(2),
          utilizador: users[Math.floor(Math.random() * users.length)]
        });
      }
    });
  }
  return data;
};

// Gerar dados de água
const generateWaterData = (days = 30) => {
  const data = [];
  const sites = ['Pragal', 'Santa Apolónia', 'Évora', 'Freixo'];
  
  for (let i = days; i >= 0; i--) {
    const date = subDays(new Date(), i);
    sites.forEach(site => {
      const baseConsumption = Math.floor(Math.random() * (150 - 50) + 50);
      data.push({
        data: format(date, 'yyyy-MM-dd'),
        local: site,
        consumo: baseConsumption + Math.floor(Math.random() * 20),
        desvio: (Math.random() * 15 - 7.5).toFixed(1)
      });
    });
  }
  return data;
};

// Gerar dados dos elevadores
const generateElevatorData = (days = 30) => {
  const data = [];
  const sites = ['Pragal', 'Santa Apolónia', 'Évora', 'Freixo'];
  const users = ['Sistema', 'Manutenção', 'Operacional'];
  
  for (let i = days; i >= 0; i--) {
    const date = subDays(new Date(), i);
    sites.forEach(site => {
      const numElevators = Math.floor(Math.random() * 3) + 2;
      for (let j = 1; j <= numElevators; j++) {
        const ativo = Math.floor(Math.random() * 400) + 200;
        const parado = Math.floor(Math.random() * 100) + 50;
        const avariado = Math.random() < 0.1 ? Math.floor(Math.random() * 60) : 0;
        data.push({
          data: format(date, 'yyyy-MM-dd'),
          local: site,
          elevador: `E${j}`,
          ativo: ativo,
          parado: parado,
          avariado: avariado,
          utilizador: users[Math.floor(Math.random() * users.length)]
        });
      }
    });
  }
  return data;
};

// Dados agregados para gráficos mensais
// Gera dados para os meses específicos onde temos dados reais de água
const generateMonthlyData = (months = 12) => {
  const data = [];
  // Gerar dados para os últimos meses, começando do mais antigo
  for (let i = months; i >= 0; i--) {
    const date = subDays(new Date(), i * 30);
    data.push({
      mes: format(date, 'MMM yyyy'),
      energia: Math.floor(Math.random() * (15000 - 10000) + 10000),
      fotovoltaico: Math.floor(Math.random() * (8000 - 5000) + 5000),
      carregamento: Math.floor(Math.random() * (3000 - 1500) + 1500),
      agua: Math.floor(Math.random() * (5000 - 3000) + 3000),
      elevadores: Math.floor(Math.random() * (10000 - 6000) + 6000)
    });
  }
  return data.reverse();
};

// Dados mensais estáticos para os meses com dados reais de água (Dec 2025, Jan 2026)
const staticMonthlyData = [
  {
    mes: 'Dec 2025',
    energia: 12500,
    fotovoltaico: 6800,
    carregamento: 2200,
    agua: 0, // será substituído por dados reais
    elevadores: 8500
  },
  {
    mes: 'Jan 2026',
    energia: 13200,
    fotovoltaico: 5900,
    carregamento: 2450,
    agua: 0, // será substituído por dados reais
    elevadores: 9100
  }
];

export const mockData = {
  energia: generateEnergyData(30),
  fotovoltaico: generateSolarData(30),
  carregamento: generateChargingData(30),
  agua: generateWaterData(30),
  elevadores: generateElevatorData(30),
  mensal: generateMonthlyData(12),
  mensalEstatico: staticMonthlyData // Dados estáticos para período com água real
};

// Mock user data
export const mockUser = {
  nome: 'João Silva',
  email: 'joao.silva@infraestruturasdeportugal.pt',
  cargo: 'Gestor Técnico',
  foto: 'https://ui-avatars.com/api/?name=Joao+Silva&background=003D7A&color=fff'
};
